import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavigationBar from './components/NavigationBar';
import MechanismSection from './components/MechanismSection';
import WinnersSection from './components/WinnersSection';
import RulesAndContact from './components/RulesAndContact';
import NewComponent from './components/NewComponent';
import './App.scss';
import Mechanism2 from './components/Mechanism2';
import AdminRoute from './components/admin/AdminRoute';
import AdminLayout from './components/admin/AdminLayout';
import AdminLogin from './components/admin/AdminLogin';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminCodes from './components/admin/AdminCodes';
import AdminParticipants from './components/admin/AdminParticipants';
import AdminWinners from './components/admin/AdminWinners';

const PublicHome: React.FC = () => (
  <div className="App">
    <NavigationBar />
    <section>
      <Mechanism2 />
    </section>
    <section>
      <MechanismSection />
    </section>
    <section id="lista-dobitnika">
      <WinnersSection />
    </section>
    <section id="pravila-kontakt">
      <RulesAndContact />
    </section>
  </div>
);

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PublicHome />} />
        <Route
          path="/prijava"
          element={
            <div className="App">
              <NavigationBar />
              <NewComponent />
            </div>
          }
        />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminLayout />
            </AdminRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="kodovi" element={<AdminCodes />} />
          <Route path="takmicari" element={<AdminParticipants />} />
          <Route path="dobitnici" element={<AdminWinners />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
